
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeMilitaryOutlined as ObiVesselTypeMilitaryOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-military-outlined.js';
 
 
 

 
 export const ObiVesselTypeMilitaryOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-military-outlined',
   elementClass: ObiVesselTypeMilitaryOutlinedElement,
   events: {
     
   }
  });
 
 